export const DEFAULT_STATE = {
    data: null,
    error: null,
    isLoading: false,
    status: null,
    statuses: null,
};
